import { FC } from 'react';

import Heading from 'molecules/Heading';
import Icon from 'molecules/Icon';
import Image from 'molecules/Image';
import Section from 'molecules/Section';
import { splitSectionProps } from 'molecules/Section/config';

import ScrollFadeSection from 'components/Animations/ScrollFadeSection';
import { HeroWithImageConfigProps } from 'components/Hero/config';

const HeroLeftAligned: FC<HeroWithImageConfigProps> = props => {
  const { sectionProps, rest } = splitSectionProps(props);
  const { featuredImage, eyebrow, eyebrowWords, heading, body, buttons, as, secondaryCta } = rest;

  const hasSecondaryCta = Boolean(secondaryCta?.text && secondaryCta?.url);

  const renderSecondaryCta = () => {
    if (!hasSecondaryCta) {
      return null;
    }

    return (
      <ScrollFadeSection delay={0.35} animateOnMount>
        <div className="flex items-center justify-start gap-1">
          <a
            href={secondaryCta?.url || '#'}
            target={secondaryCta?.openInNewTab ? '_blank' : '_self'}
            rel={secondaryCta?.openInNewTab ? 'noopener noreferrer' : undefined}
            className="group flex items-center gap-1.5 text-lg font-medium text-gray-300 transition-colors hover:text-gray-400"
          >
            <span>{secondaryCta?.text || 'Lorem ipsum'}</span>
            <Icon icon="arrow-up-right" size={20} className="transition-transform group-hover:translate-x-0.5" />
          </a>
        </div>
      </ScrollFadeSection>
    );
  };

  return (
    <Section {...sectionProps}>
      <div className="flex flex-col items-start justify-start gap-8 sm:gap-16 lg:flex-row lg:gap-[50px]">
        <div className="flex w-full flex-col gap-6 lg:w-1/2">
          <Heading
            eyebrow={eyebrow}
            eyebrowWords={eyebrowWords}
            heading={heading}
            body={body}
            buttons={buttons}
            alignment="left"
            size="lg"
            as={as || 'h1'}
            animateOnMount
          />
          {renderSecondaryCta()}
        </div>
        <div className="relative w-full lg:h-[600px] lg:w-1/2">
          <div className="h-full rounded-[11px] bg-heroFeaturedBg p-1.5 drop-shadow-heroFeaturedBoxShadow backdrop-blur-[2px] sm:p-3.5 lg:absolute lg:left-[10%] lg:p-0">
            <Image
              url={featuredImage?.file?.url || ''}
              alt={featuredImage?.alt || ''}
              {...featuredImage?.file}
              noFill
              priority
              className="size-full object-cover"
            />
          </div>
        </div>
      </div>
    </Section>
  );
};

export default HeroLeftAligned;
